<template>
  <div id="app">
    <nav>
      <ul>
        <li class="buscardor"><buscador v-bind:arrayCriptoOriginal="arrayCriptoOriginal" v-bind:arrayCripto="arrayCripto" v-on:tengo_resultados="onResultados"></buscador></li>
        <router-link id="index-nav" :to="'/'">
          <li href>Index</li>
        </router-link>
        <!-- <li class="botones-nav">grafica</li>
        <li class="botones-nav">Chart</li> -->
      </ul>
    </nav>
    <router-view v-bind:arrayCripto="arrayCripto"/>
  </div>
</template>
<script>
import index from './components/index'
import buscadorc from './components/buscador'
import { generalStatus } from './services/multiSnifferService'
export default {
  name: 'App',
  components: {
    index,
    buscadorc
  },
  data () {
    return {
      message: 'Hello Vue.js!',
      buscar: '',
      arrayCripto: [],
      arrayCriptoOriginal: []
    }
  },
  methods: {
    async cardListBincon () {
      let m = this
      await generalStatus().then(function (response) {
        var respuesta = response.data
        m.arrayCripto = respuesta
        m.arrayCriptoOriginal = respuesta
      }).catch(function (error) {
        console.log(error)
      })
    },
    onResultados (datos) {
      this.arrayCripto = datos
    }
  },
  created () {
  },
  mounted () {
    this.cardListBincon()
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

#index-nav {
  text-decoration: none;
  color: white;
  margin: 0px 3% 0px 10px;
  padding: 10px;
}

body{
  margin: 0;
  padding: 0;
}
.nav-index{
  border:2px solid;
}

nav {
  border: 1px solid  #6d7278;
  background:  #6d7278;
  color: white;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}

nav ul {
    display: flex;
    list-style: none;
    align-items: center;
    justify-content: flex-end;
    animation-delay: inherit;
    cursor: pointer;
    margin-bottom: 0px;
    margin-top: 0px;
}

nav ul li:hover{
  color: black;
  background: lightgray;
}

nav ul .botones-nav{
  margin: 0 10px;
  padding: 10px;
}

nav ul li input{
    background: transparent;
    border: transparent;
    border-bottom: 1px solid white;
    height: 42px;
    width: auto;

}

@media (max-width: 320px) {
  nav ul{
    font-size: 15px;
  }

  nav ul li:hover{
    color: black;
    background: lightgray;
  }
  nav ul .botones-nav{
    margin: 0 5px;
  }

  nav ul li input{
    width: 100px;
    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue